// extracted by mini-css-extract-plugin
module.exports = {"reveo_cta_wrapper":"offers_reveo_cta_wrapper__1-kLL"};